module.exports = __webpack_public_path__ + "media/components/home/creator-community/img/cinemitch-bkg-fb310efd9d4d0998ef964420bd4a8018.jpg";